const toVn = (price = 0) => {
  if (Number.isNaN(Number(price))) return price;

  const toFixed = price.toFixed(0);

  return `${Number(toFixed).toLocaleString('vn')} ₫`;
};

const dot = (price = 0) => {
  if (Number.isNaN(Number(price))) return price;

  if (typeof price === 'number') {
    return `${price.toLocaleString('ko')}`;
  }
};

export { toVn, dot };
